// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".version-badge[data-v-73ec8d6f]{width:112px;height:32px;background:var(--v-gray-extra-light);border-radius:16px;margin-right:var(--spacer)}.version-badge span[data-v-73ec8d6f]{font-size:12px;letter-spacing:.2px;color:var(--v-blue-primary)}.version-badge .version-number[data-v-73ec8d6f]{font-size:16px;letter-spacing:.33px;font-weight:var(--font-weight-medium);margin-left:6px}", ""]);
// Exports
module.exports = exports;
